import { render, staticRenderFns } from "./Reconnect.vue?vue&type=template&id=71e98220&scoped=true&"
import script from "./Reconnect.vue?vue&type=script&lang=ts&"
export * from "./Reconnect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e98220",
  null
  
)

export default component.exports